import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function HighHeeledShoes(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 1028 1024" {...props}>
      <path d="M902.4 96c0 0-492.8 588.8-556.8 665.6-64 76.8-70.4 32-153.6 64C108.8 864 0 960 0 960l390.4 0C505.6 960 512 883.2 512 883.2s32-166.4 166.4-288c134.4-121.6 313.6-115.2 313.6-115.2C1107.2 160 902.4 96 902.4 96zM800 550.4c57.6 44.8 64 422.4 64 422.4l70.4 0c-12.8-166.4 38.4-448 38.4-448C902.4 486.4 800 550.4 800 550.4zM51.2 1024l345.6 0 38.4-25.6L19.2 998.4 51.2 1024z"></path>
    </SvgIcon>
  );
}
